import { GLOBALS } from "../../js/globals";

export const preloader = new Promise((resolve, reject) => {
    setTimeout(() => {
        document.querySelector('.js-preloader-img').classList.add('_is-active');
    }, 1);

    setTimeout(() => {
        GLOBALS.H.classList.add('_is-preloaded');
        resolve();
    }, 5000);
});
